import { Button, Modal, TextField, Autocomplete } from "@mui/material";
import InputField from "components/Input/InputField";
import { AiOutlineDelete } from "react-icons/ai";
import { months } from "const/constants";

const ScholarshipModal = ({
  open,
  onClose,
  selectedScholarshipCourse,
  setSelectedScholarshipCourse,
  onSave,
}) => {
  const addNewScholarship = () => {
    setSelectedScholarshipCourse((prev) => ({
      ...prev,
      scholarships: [...(prev.scholarships || []), { intake: [], scholarship: "", note: "" }],
    }));
  };

  const removeScholarship = (index) => {
    setSelectedScholarshipCourse((prev) => ({
      ...prev,
      scholarships: prev.scholarships.filter((_, i) => i !== index),
    }));
  };

  const handleScholarshipChange = (index, field, value) => {
    setSelectedScholarshipCourse((prev) => ({
      ...prev,
      scholarships: prev.scholarships.map((scholarship, i) =>
        i === index ? { ...scholarship, [field]: value } : scholarship
      ),
    }));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiModal-root": {
          width: "800px",
          maxWidth: "800px",
          margin: "0 auto",
        },
      }}
    >
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-app-surface p-6 rounded-lg shadow-xl w-min-[900px]">
        <h3 className="text-lg font-semibold mb-4">Scholarship Details</h3>

        <table className="w-full border">
          <thead>
            <tr>
              <th className="px-4 py-2 border max-w-[400px] w-[400px]">Intake</th>
              <th className="px-4 py-2 border ">Scholarship</th>
              <th className="px-4 py-2 border">Note</th>
              <th className="px-4 py-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {selectedScholarshipCourse?.scholarships?.map((scholarship, idx) => (
              <tr key={idx}>
                <td className="px-4 py-2 border">
                  <Autocomplete
                    onChange={(e, value) => {
                      handleScholarshipChange(idx, "intake", value?.value);
                    }}
                    required
                    value={months.find((month) => month.value === scholarship.intake) || null}
                    placeholder="Select Intakes"
                    options={months || []}
                    isOptionEqualToValue={(options, value) => options.value === value.value}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Intakes"
                        type="search"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password",
                        }}
                      />
                    )}
                    ListboxProps={{
                      style: {
                        maxHeight: "180px",
                      },
                    }}
                    size="small"
                  />
                </td>
                <td className="px-4 py-2 border">
                  <InputField
                    type="number"
                    value={scholarship.scholarship}
                    onChange={(e) => handleScholarshipChange(idx, "scholarship", e.target.value)}
                    endIcon={"%"}
                  />
                </td>
                <td className="px-4 py-2 border">
                  <InputField
                    type="text"
                    value={scholarship.note}
                    onChange={(e) => handleScholarshipChange(idx, "note", e.target.value)}
                    outerClassName="w-[200px]"
                  />
                </td>
                <td className="px-4 py-2 border">
                  <button
                    type="button"
                    onClick={() => removeScholarship(idx)}
                    className="text-red-600 hover:text-red-800"
                  >
                    <AiOutlineDelete />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <Button variant="outlined" onClick={addNewScholarship} className="mt-4">
          Add Row
        </Button>

        <div className="flex justify-end gap-4 mt-6">
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onSave}>
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ScholarshipModal;
